import { useState } from 'react'

import { friction, ru } from '../../lib/physics'
import { Predict } from './common'

/**
 * Догружаем брусок (урок 39): брусок 1,9 Н, каждый груз — 1 Н. Протягиваем равномерно,
 * записываем вес и силу трения скольжения. Отношение Fтр : N всё время одно — около 0,21:
 * это коэффициент трения дерева по лакированному столу.
 */

const БРУСОК = 1.9 // Н
const μ = 0.4 / 1.9

export default function LoadLab() {
  const [грузов, setГрузов] = useState(0)
  const [замеры, setЗамеры] = useState<{ вес: number; fтр: number }[]>([])

  const вес = БРУСОК + грузов
  const протянуть = () => {
    // тянем чуть сильнее предела — брусок едет равномерно, динамометр показывает трение скольжения
    const { Fтр } = friction(μ * вес + 1e-6, μ, вес)
    setЗамеры((z) => (z.some((r) => Math.abs(r.вес - вес) < 1e-9) ? z : [...z, { вес, fтр: Fтр }].sort((a, b) => a.вес - b.вес)))
  }

  return (
    <div className="card">
      <svg className="lab-svg" viewBox="0 0 360 130" role="img" aria-label="Брусок с грузами">
        <rect x={0} y={100} width={360} height={10} className="fill-ruler" />
        <rect x={110} y={66} width={110} height={34} rx={3} className="fill-body ink" strokeWidth={1.5} />
        {Array.from({ length: грузов }, (_, i) => (
          <rect key={i} x={124 + i * 22} y={44} width={18} height={22} rx={2} className="fill-muted ink" strokeWidth={1} />
        ))}
        <text x={165} y={88} textAnchor="middle" className="lab-label">{ru(вес, 1)} Н</text>
      </svg>

      <div className="row-wrap">
        <button className="btn" disabled={грузов >= 4} onClick={() => setГрузов((g) => g + 1)}>+ груз 1 Н</button>
        <button className="btn" disabled={грузов === 0} onClick={() => setГрузов((g) => g - 1)}>− груз</button>
        <button className="btn btn-primary" onClick={протянуть}>➡️ Протянуть равномерно</button>
      </div>

      {замеры.length > 0 && (
        <table className="lab-table">
          <thead>
            <tr><th>вес N, Н</th><th>F тр, Н</th><th>F тр : N</th></tr>
          </thead>
          <tbody>
            {замеры.map((r) => (
              <tr key={r.вес}><td>{ru(r.вес, 1)}</td><td>{ru(r.fтр, 2)}</td><td>{ru(r.fтр / r.вес, 2)}</td></tr>
            ))}
          </tbody>
        </table>
      )}

      <Predict
        question="При весе 1,9 Н трение 0,4 Н, при 3,9 Н — 0,8 Н. Каким будет трение при весе 5,9 Н?"
        options={['0,8 Н', 'около 1,2 Н', '5,9 Н']}
        right={1}
        revealed={замеры.some((r) => Math.abs(r.вес - 5.9) < 1e-9)}
        explain="Сила трения скольжения пропорциональна силе нормального давления: F тр = μ·N = 0,21 · 5,9 Н ≈ 1,2 Н."
      />
      <p className="muted small">
        Тянут равномерно — значит, сила тяги равна силе трения, и динамометр показывает трение.
        Отношение F тр : N не зависит от груза — это коэффициент трения μ, он зависит от поверхностей.
      </p>
    </div>
  )
}
